import { CSSProperties, useMemo } from 'react'

// Utils
import numberToRem from '@src/quince-site-common/src/utils/numberToRem'
import classnames from 'classnames'
import { RichText, RichTextProps } from '../../molecules/RichText'
import { Image, ImageProps } from '../image'
import styles from './iconWithText.module.scss'

export interface IconWithTextProps {
  iconProps?: ImageProps
  heading?: RichTextProps | null
  description?: RichTextProps
  className?: string
  hasBorder?: boolean
  maxImageWrapperHeight?: number
  imageWrapperClassName?: string
}

export const IconWithText = ({ className = '', ...props }: IconWithTextProps) => {
  const wrapClassnames = classnames(styles.iconWithTextWrap, className)
  const maxImageWrapperHeight = useMemo(
    () =>
      ({
        '--maxImageWrapperHeight': props.maxImageWrapperHeight
          ? numberToRem(props.maxImageWrapperHeight, undefined)
          : undefined,
      }) as CSSProperties,
    [props.maxImageWrapperHeight],
  )
  return (
    <div className={wrapClassnames}>
      {props.iconProps && (
        <div style={maxImageWrapperHeight} className={classnames(styles.imageWrapper, props.imageWrapperClassName)}>
          <Image {...props.iconProps} className={classnames(styles.icon, props.iconProps.className)} useNative />
        </div>
      )}
      <div className={styles.contentWrapper}>
        {props.heading && <RichText {...props.heading} />}
        {props.description && <RichText {...props.description} />}
      </div>
    </div>
  )
}

export default IconWithText
